import { AxiosError } from 'axios'

import { IErrorDTO } from '@/DTOs/errorDTO'

const defaultErrorMsg = 'Por favor, tente novamente mais tarde.'

// Sem `axios.isAxiosError`: o jest do CRA não transforma o axios (ESM).
const isAxiosError = (error: unknown): error is AxiosError<IErrorDTO> =>
  typeof error === 'object' &&
  error !== null &&
  'isAxiosError' in error &&
  error.isAxiosError === true

/**
 * Extracts the first error detail from API response.
 *
 * @param {AxiosError<IErrorDTO>} error - The error object returned by Axios.
 * @returns {string} - The detail of the first error or a default error message.
 */
const getFirstErrorDetail = (error: AxiosError<IErrorDTO>): string => {
  try {
    const errorDetail = error.response?.data.errors[0]?.detail
    return errorDetail ?? defaultErrorMsg
  } catch {
    return defaultErrorMsg
  }
}

/**
 * Retrieves a user-friendly error message.
 *
 * @param {unknown} error - Whatever a `catch` received; only an Axios error
 * with a response carries a detail.
 * @returns {string} - A user-friendly error message.
 */
export function getErrorDetails(error: unknown): string {
  if (isAxiosError(error) && error.response) {
    return getFirstErrorDetail(error)
  }

  return defaultErrorMsg
}
